import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ModernDateTimePickerComponent } from '../modern-date-time-picker/modern-date-time-picker.component';

/**
 * Legacy wrapper component for backward compatibility.
 * This component now uses the modern PrimeNG-based date-time picker internally.
 * All existing usages will continue to work without changes.
 */
@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: true,
  imports: [ModernDateTimePickerComponent],
})
export class DateTimePickerComponent {
  @Input() public label = '';
  @Input() public startingValue?: Date;
  @Input() public minDate?: Date;
  @Input() public maxDate?: Date;
  @Output() public dateOnSelection = new EventEmitter<Date | undefined>();

  /**
   * This event is sent from outside the date picker.
   * It will be triggered when we have a new value for the date picker that wasn't triggered using the date picker itself.
   * This will be mostly used by the changes on the query params.
   */
  @Input() public newValueTriggered$?: Observable<Date | undefined>;
}
